import "@sakai-ui/sakai-date-picker/sakai-date-picker.js";
import "@sakai-ui/sakai-user-photo/sakai-user-photo.js";
import "imagesloaded";
import "@sakai-ui/sakai-profile/sakai-profile.js";
import "@sakai-ui/sakai-account/sakai-account.js";
import "@sakai-ui/sakai-pronunciation-player/sakai-pronunciation-player.js";
import "@sakai-ui/sakai-picture-changer/sakai-picture-changer.js";
import "@sakai-ui/sakai-notifications/sakai-notifications.js";
import "@sakai-ui/sakai-calendar/sakai-calendar.js";
import "@sakai-ui/sakai-course-card/sakai-course-card.js";
import "@sakai-ui/sakai-tag-selector/sakai-tag-selector.js";

import imagesLoaded from "imagesloaded";
globalThis.imagesLoaded = imagesLoaded;
import Sortable from "sortablejs";
globalThis.Sortable = Sortable;

import { loadProperties, tr } from "@sakai-ui/sakai-i18n";
globalThis.loadProperties = loadProperties;
globalThis.tr = tr;

import "@sakai-ui/sakai-timer-bar/sakai-timer-bar.js";
import "@sakai-ui/sakai-gradebook-item-selector/sakai-gradebook-item-selector.js";
import "@sakai-ui/sakai-conditions/sakai-condition-editor.js";
import "@sakai-ui/sakai-conditions/sakai-condition-picker.js";
import "@sakai-ui/sakai-rubrics/sakai-dynamic-rubric.js";
